<template>
    <div class="goods-detail-item" v-if="chainList.length">
        <a href="javascript:;" @click="bindGoChain()">
            <div class="chain-title">
                <span>门店购买</span>
            </div>
            <div class="chain-content">
                <img :src="currentChain.imageSrc2">
                <div class="chain-info">
                    <p class="chain-name">{{currentChain.chainName}}</p>
                    <p class="chain-address">{{currentChain.areaInfo + currentChain.address}}</p>
                </div>
                <div class="chain-right">
                    <span>{{currentChain.className}}</span><i></i>
                </div>
            </div>
        </a>
    </div>
</template>
<script>
    // js 区域


    export default {
        //外部传入参数
        props: {
            // 当前skuid
            goodsId: {
                type: Number,
                default: null
            },
            //地区对象 {areaId : currentAreaId , areaId3 : currentAreaId3}
            areaObj: {
                type: Object,
                default: null
            }
        },
        /*
         * 自身数据,一定要一个function
         */
        data() {
            return {
                // 门店列表
                chainList: []
            }
        },
        /**
         * 计算属性
         */
        computed: {
            currentChain (){
                return this.chainList.length ? this.chainList[0] : null
            }
        },

        /**
         * 监听属性变动
         */
        watch: {
            goodsId(newValue, oldValue){
                if (newValue && !this.$isEmpty( this.areaObj ) ) {
                    this.loadData()
                } else {
                    this.chainList = []
                }
            },
            areaObj (newValue, oldValue){
                console.log(this)
                if (newValue && !this.$isEmpty(newValue)) {
                    this.loadData()
                } else {
                    this.chainList = []
                }
            }
        },

        /**
         * 自定义方法
         */
        methods: {
            // 加载门店数据
            loadData (){
                var self = this
                $.get(ApiUrl + '/chain/list', {
                    areaId3:this.areaObj.areaId3 ,
                    areaId2: this.areaObj.areaId,
                    goodsId: this.goodsId
                }, function (xhr) {
                    if (xhr.code === 200) {
                        self.chainList = xhr.datas.chainList
                        self.$nextTick(() => {
                            self.$emit('refresh')
                        })
                    }
                })
            },
            // 去门店
            bindGoChain(){
                this.$emit('navigate-to-chain-list')
            },
            isEmpty: function (value) {
                  return Nc.isEmpty(value)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/goods-chain/goods-chain.vue